//
//
//
//
//
//
//
//

import MHeader from './Header.vue';
import TopNav from './TopNav.vue';
import BtmNav from './BtmNav.vue';
import {
    getUCTN,
    getUserInfoByToken
} from '../../api';
export default {
    data() {
        return {}
    },
    components: {
        MHeader,
        TopNav,
        BtmNav
    },
    methods: {
        getUserInfo() {
            if (!this.$store.state.userInfo.headimgurl) {
                // getUserInfoByToken().then(res => {
                //     console.log(res);
                //     this.$store.commit('updateUserInfo', {
                //         headimgurl: res.data.MerList.head,
                //         user_name: res.data.MerList.nickname
                //     });
                // });
            }
        }
    },
    beforeRouteEnter: (to, from, next) => {
        // getUCTN();
        next(vm => vm.getUserInfo());
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/UserCenter.vue